import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import React from "react";

import { AnimatedCheck } from "./animatedCheck";

type SuccessModalProps = {
  onClose: () => void;
};

export const SuccessModal = ({ onClose }: SuccessModalProps) => {
  return (
    <Dialog open onClose={() => {}} className="relative z-50">
      <div className="fixed inset-0 bg-black/40" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-xl">
          <div className="flex justify-center">
            <AnimatedCheck />
          </div>
          <DialogTitle className="mt-6 text-xl font-semibold tracking-tight text-gray-900">
            Account deletion request submitted successfully.
          </DialogTitle>
          <p className="mt-3 text-base text-gray-600">
            It typically takes 5-10 business days to process your account deletion request.
          </p>
          <button
            type="button"
            onClick={onClose}
            autoFocus
            className="mt-8 inline-flex w-full items-center justify-center rounded-full bg-gray-900 px-8 py-3 font-medium text-white hover:brightness-110 sm:w-auto transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900"
          >
            Close
          </button>
        </DialogPanel>
      </div>
    </Dialog>
  );
};
